module.exports = __webpack_require__.p + "4b5ba3d52f9ca29cce153934d9160f8a.jpg";